module.exports = __webpack_public_path__ + "04df54b9044b4b023be2a8f0a4d27f23.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-jester.png
// module id = 2883
// module chunks = 0